<template>
	<div class="user-side-form">
		<el-row :gutter="20">
			<el-col :span="9">
				<!-- 다국어: 언어 -->
				<label>{{ getMessage_('SWCC000397') }}</label>
			</el-col>
			<el-col :span="14">
				<el-select v-model="language" @change="changeLanguage">
					<el-option v-for="(lang, index) in languages" :key="index" :label="lang.label" :value="lang.value">
						<div class="user-setting-select-option">
							<div class="user-setting-select-option__lang">
								<!-- 나라별 국기 이미지 -->
								<img :src="`/img/lang/lang-${lang.value}.png`" alt="" />
							</div>
							<div class="user-setting-select-option__content">{{ lang.label }}</div>
						</div>
					</el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="9">
				<!-- 다국어: 색상 -->
				<label>{{ getMessage_('SWCC000395') }}</label>
			</el-col>
			<el-col :span="14">
				<el-select :value="skinTheme" @change="changeColor">
					<el-option v-for="(color, index) in colors" :key="index" :label="color.label" :value="color.value">
						<div class="user-setting-select-option">
							<!-- 테마 색상 표시 -->
							<div :class="'user-setting-select-option__color select-option--' + color.value"></div>
							<div class="user-setting-select-option__content">{{ color.label }}</div>
						</div>
					</el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="9">
				<!-- 다국어: 폰트 -->
				<label>{{ getMessage_('SWCC000396') }}</label>
			</el-col>
			<el-col :span="14">
				<el-select :value="fontTheme" @change="changedFont">
					<el-option v-for="(font, index) in fonts" :key="index" :label="font.label" :value="font.value">
						<div class="user-setting-select-option">
							<div :class="`user-setting-select-option__content ${font.value}`">{{ font.label }}</div>
						</div>
					</el-option>
				</el-select>
			</el-col>
		</el-row>
	</div>
</template>

<script>
//사용자 설정 사이드 바의 설정 Form

//moment의 다국어 처리를 위한 설정들 import
import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';

//el-element의 다국어 처리를 위한 설정들 import
import locale from 'element-ui/lib/locale';
import koLocale from 'element-ui/lib/locale/lang/ko';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

import { rootComputed, rootMethods } from '@/store/common/helpers';

export default {
	created() {
		this.language = this.langCd; //언어
		this.skinTheme = this.topSkin; //색상 테마
		this.fontTheme = this.font; //폰트 테마
	},

	data() {
		return {
			language: 'en_US', //언어 기본 값
			skinTheme: 'default', //색상 테마 기본 값
			fontTheme: 'HyundaiSans' //폰트 테마 기본 값
		};
	},
	computed: {
		...rootComputed,

		themeList() {
			return process.env.VUE_APP_THEME_LIST.split('|').map(theme => JSON.parse(theme));
		},

		// 언어 종류(selectBox 옵션)
		//store의 사용자 정보에 따른 다국어를 반영하여 selectBox 옵션 구성
		languages() {
			return [
				{ label: this.getMessage_('SWCC000462'), value: 'ko_KR' }, //다국어: 한국어
				{ label: this.getMessage_('SWCC000464'), value: 'en_US' }, //다국어: 영어
				{ label: this.getMessage_('SWCC000463'), value: 'zh_CH' } //다국어: 중국어
			];
		},

		// 색상 테마 종류(selectBox 옵션)
		colors() {
			return [
				//...this.themeList,				
				{ label: 'Black', value: 'default-black' },
				{ label: 'Grey', value: 'default-grey' },
				{ label: 'Blue', value: 'default-blue' },
				{ label: 'Htwo(sample1)', value: 'htwo-theme1' },
				{ label: 'Htwo(sample2)', value: 'htwo-theme2' },
				//{ label: 'White', value: 'default-white' },
				
				
				
				//{ label: 'Kia(Black)', value: 'kia-black' },
				//{ label: 'Kia(Red)', value: 'kia-red' },
				//{ label: 'Genesis(Black)', value: 'genesis-black' }
			];
		},

		// 테마 종류(selectBox 옵션)
		//store의 사용자 정보에 따른 다국어를 반영하여 selectBox 옵션 구성
		fonts() {
			return [
				{ label: this.getMessage_('SWCC000722'), value: 'HyundaiSans' }, //다국어: 현대산스
				{ label: this.getMessage_('SWCC000493'), value: 'default' }, //다국어: 기본
				{ label: this.getMessage_('SWCC000494'), value: 'hyundai' }, //다국어: 현대하모니
				{ label: this.getMessage_('SWCC000495'), value: 'kia' }, //다국어: 기아M
				{ label: this.getMessage_('SWCC000496'), value: 'nanumGothic' } //다국어: 나눔고딕
			];
		}
	},

	watch: {
		//store의 사용자 언어 변경 감시
		langCd(val) {
			this.language = val; //언어 변경시 From 에 반영

			//바뀐 언어에 맞게 el-element 의 다국어 변경
			switch (val) {
				case 'ko_KR':
					moment.locale('ko');
					locale.use(koLocale);
					break;
				case 'en_US':
					moment.locale('en');
					locale.use(enLocale);
					break;
				case 'zh_CH':
					moment.locale('zh_cn');
					locale.use(zhLocale);
					break;
				default:
					moment.locale('en');
					locale.use(enLocale);
					break;
			}

			Vue.use(vueMoment, { moment });
		},

		//store의 사용자 색상 테마 변경 감시
		topSkin(val) {
			this.skinTheme = val; //색상 테마 변경시 From 에 반영
		},

		//store의 사용자 폰트 테마 변경 감시
		font(val) {
			this.fontTheme = val; //폰트 테마 변경시 From 에 반영
		}
	},

	methods: {
		...rootMethods,

		//Cookie Set 함수
		setCookie(key, value) {
			document.cookie = `${key}=${value}`;
		},

		//Form에서 언어 변경시
		changeLanguage(e) {
			this.$sf_toggleLoading(true);

			//사용자 언어 변경 Action 호출
			this.updateLangCd_({ langCd: e })
				.then(header => {
					//사용자 언어 변경 성공 시
					if (header.code === 0) {
						//바뀐 언어에 맞게 el-element 의 다국어 변경
						switch (e) {
							case 'ko_KR':
								locale.use(koLocale);
								break;
							case 'en_US':
								locale.use(enLocale);
								break;
							case 'zh_CH':
								locale.use(zhLocale);
								break;
							default:
								locale.use(enLocale);
								break;
						}

						this.setCookie('language', this.language); //언어 쿠키에 저장
					}

					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//Form에서 색상 테마 변경시
		changeColor(e) {
			this.$sf_toggleLoading(true);

			//사용자 색상 테마 변경 Action 호출
			this.updateTopSkin_({ topSkin: e })
				.then(header => {
					document.body.setAttribute('data-theme', e); //색상 테마 변경

					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//Form에서 폰트 테마 변경시
		changedFont(e) {
			this.$sf_toggleLoading(true);

			//사용자 폰트 테마 변경 Action 호출
			this.updateFont_({ font: e })
				.then(header => {
					document.body.setAttribute('font-theme', e); //폰트 테마 변경

					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
